module.exports = __webpack_public_path__ + "img/upload_photo3.647dbbfe.jpg";